import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'pcs-multi-select-badge',
  templateUrl: './multi-select-badge.component.html',
  styleUrls: ['./multi-select-badge.component.scss']
})
export class MultiSelectBadgeComponent {
  @Input() text;
  @Input() clickable = false;

  @Output() badgeClick = new EventEmitter();

  get badgeClasses() {
    return this.clickable ? 'badge-primary' : 'badge-default';
  }

  @HostListener('click')
  onClick() {
    if (this.clickable) {
      this.badgeClick.emit();
    }
  }
}
